export enum ElementType {
  Select = "select",
  Textfield = "text",
  DatePicker = "date",
  Radio = "radio",
  Checkbox = "checkbox",
  AdormentTextfield = "adormentTextfield",
}
